var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"position-fixed d-flex flex-column",attrs:{"id":"app-header-wrapper"}},[_c('div',{staticClass:"d-flex flex-lg-column",attrs:{"id":"app-header"}},[_c('Logo'),_c('NavPrimary',{staticClass:"mx-auto w-100"}),_c('NavSecondary',{staticClass:"d-none d-lg-block"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }